import React, { useState, useEffect, useRef } from "react";
import "src/components/presentation.css";
import { EventsContext } from "src/contexts/context";
import DashboardLayout from "src/pages/DashBoardLayout/DashboardLayout";
import Testing from "src/components/Testing/testing";
import EventsSocket from "src/components/Events/Events_Stomp";

const App = () => {
  const containerRef = useRef(null);

  const [horizontalHeightPercentage, setHorizontalHeightPercentage] =
    useState(98);
  const [isResizing, setIsResizing] = useState(false);
  const [containerHeight, setContainerHeight] = useState(window.innerHeight);

  
  const [show, showEvents] = useState(false);
  
  const [iframePositions, setIframePositions] = useState({
    top: { id: "iframe1", component: <DashboardLayout />, isOpen: true },
    bottom: { id: "iframe2", component: <Testing/>, isOpen: true },
  });

  useEffect(() => {
    const handleResize = () => {
      const containerElement = containerRef.current;
      if (containerElement) {
        setContainerHeight(containerElement.offsetHeight);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDragStart = (event, itemId) => {
    event.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };
  const handleShow = () => {
    setHorizontalHeightPercentage(70);
    showEvents(true);
  };

  const handleClose = () => {
    setHorizontalHeightPercentage(98);
    showEvents(false);
  };

  const handleHorizontalResize = (event) => {
    const containerTop = containerRef.current.getBoundingClientRect().top;
    const newHeight = event.clientY - containerTop;
    const newHeightPercentage = (newHeight / containerHeight) * 100;
    if (newHeightPercentage <= 98 && newHeightPercentage >= 33) {
      setHorizontalHeightPercentage(
        Math.max(0, Math.min(newHeightPercentage, 100))
      );
    }
  };

  const handleMouseDown = (event) => {
    if (show) {
      setIsResizing(true);
      const containerRect = containerRef.current.getBoundingClientRect();
      const mouseX = event.clientX - containerRect.left;
      const mouseY = event.clientY - containerRect.top;

      // Check if the mouse is within the "jj" divs
      if (
        mouseX >= 0 &&
        mouseX <= containerRect.width &&
        mouseY >= 0 &&
        mouseY <= containerRect.height
      ) {
        handleHorizontalResize(event);
      }
    }
  };

  const handleMouseMove = (event) => {
    if (isResizing) {
      handleHorizontalResize(event);
    }
  };

  const handleMouseUp = () => {
    setIsResizing(false);
  };

  useEffect(() => {
    if (isResizing) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    } else {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  });

  const getHorizontalHeight = () => `${horizontalHeightPercentage}%`;

  const isInIframe = window.self !== window.top;

  const [events, setEvents] = useState({ data: [], counter: 0 });

  return (
    <EventsContext.Provider
      value={{
        setEvents,
        events,
      }}
    >
      {!isInIframe ? (
        <div className="app-container" ref={containerRef}>
          <div
            className={`horizontal-line-split ${show ? "active" : ""}`}
            style={{ top: `calc(${getHorizontalHeight()} - 5px)` }}
            onMouseDown={handleMouseDown}
            onClick={!show ? handleShow : null}
          />
          <div
            className="top-left-area"
            style={{
              width: "100%",
              height: `calc(${getHorizontalHeight()} - 15px)`,
              display: "flex",
              overflowX: "hidden",
            }}
            onDragStart={(event) => handleDragStart(event, "top")}
            onDragOver={handleDragOver}
          >
            {iframePositions.top.isOpen && iframePositions.top.component}
          </div>
          {iframePositions.bottom.isOpen && (
            <div className="jj">
              <div
                className="bottom-area"
                style={{
                  width: `calc(100% - 62px)`,
                  // height: "fit-content",
                  bottom: 0,
                  top:"unset",
                  height: `calc(${100 - horizontalHeightPercentage}% + 15px)`,
                  maxHeight: `calc(${100 - horizontalHeightPercentage}% + 15px)`,
                  // top: `calc(${getHorizontalHeight()} - 15px)`,
                }}
                onDragStart={(event) => handleDragStart(event, "bottom")}
                onDragOver={handleDragOver}
              >
                <div className="closeButton closeButton-events">
                  {show && (
                    <button className="close-button" onClick={handleClose}>
                      X
                    </button>
                  )}
                </div>
                <div
                  className="iframe-wrapper"
                  style={{
                    maxHeight: `calc(100% - 30px)`,
                    overflow: "auto",
                  }}
                >
                  {show && iframePositions.bottom.component}
                </div>
              </div>
            </div>
          )}
          {isResizing && <div className="resizer-overlay" />}
        </div>
      ) : (
        iframePositions.top.isOpen && iframePositions.top.component
      )}
      <EventsSocket></EventsSocket>
    </EventsContext.Provider>
  );
};

export default App;
